<template>
<div class="quill-editor">
  <slot></slot>
</div>
</template>

<script>
import Quill from 'quill'
import {quillEvent} from '../../main'
export default {
  props: {
    options: {
      type: Object,
      default: () => ({})
    },
    content: String,
    autofocus: Boolean
  },
  data: () => ({
    focused: this.autofocus,
    editor: null
  }),
  beforeMount () {
    quillEvent.$on('getContent', () => {
      quillEvent.$emit('quillContent', {html: this.editor.root.innerHTML, text: this.editor.root.innerText})
    })
  },
  mounted () {
    this.editor = new Quill(this.$el, this.options)
    if (this.content) this.syncText()
  },
  watch: {
    focused (val) {
      this.editor[val ? 'focus' : 'blur']()
    }
  },
  methods: {
    syncText () {
      this.editor.root.innerHTML = this.content
    }
  }
}
</script>

<style lang="stylus">
  @import '~quill/assets/core'
</style>



// WEBPACK FOOTER //
// src/components/general/Quill.vue